import { ZfBox, ZfLoadingSpinner } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { LiquidityCalculatorGraph } from '../../../../liquidity-planner/components/liquidity-calculator/liquidity-calculator-graph';
import { useLiquidityCalculationData } from '../../../../liquidity-planner/hooks';

export const ClientPackageLiquidity: FunctionComponent = () => {
    const calculationData = useLiquidityCalculationData();

    if (calculationData.isLoading) {
        return <ZfLoadingSpinner style={{ margin: 'auto' }} />;
    }

    return (
        <ZfBox style={{ position: 'relative', display: 'flex', width: '100%', height: '100%' }}>
            <ZfBox style={{ flexGrow: 1 }}>
                <LiquidityCalculatorGraph calculationData={calculationData} exportMode />
            </ZfBox>
        </ZfBox>
    );
};
